import { fileUpload } from 'directus/src/operations';
import React, { useState, useEffect } from 'react';
import ChatAttachmentUpload from 'ui/components/chat-file-attach';

const ChatAttachmentInput = ({ value, onChange, disabled, preview = false, ...props }) => {
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState(null);
    const [shouldReset, setShouldReset] = useState(false);

    useEffect(() => {
        // Trigger reset when value becomes null
        if (value === null) {
            setShouldReset(true);
        } else {
            setShouldReset(false);
        }
    }, [value]);

    async function handleChange(file) {
        if (disabled || isUploading) return;

        setError(null);
        setShouldReset(false);

        if (file) {
            try {
                setIsUploading(true);
                const formData = new FormData();
                formData.append('file', file.file);
                const uploaded = await fileUpload(formData);
                onChange?.(uploaded.id);
            } catch (err) {
                console.error('File upload failed:', err);
                setError('Failed to upload file');
                onChange?.(null);
            } finally {
                setIsUploading(false);
            }
        } else {
            onChange?.(null);
        }
    }

    if (error) {
        return <div className="text-red-500 text-sm">{error}</div>;
    }

    return (
        <ChatAttachmentUpload
            value={value}
            onChange={handleChange}
            disabled={disabled || isUploading}
            shouldReset={shouldReset}
            preview={preview}
            {...props}
        />
    );
};

export default ChatAttachmentInput;